import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { Banner } from '../../components/banner/Banner'
import { Point } from '../../components/atom/Point'
import { Container } from 'react-bootstrap'
import EmblaCarousel from '../../components/carousel/EmblaCarousel'
import { Logo } from '../../components/atom/Logo'

const P = styled.p`
  font-size: 22px;
  margin: 0;
  flex-shrink: 0;
  width: 700px;
  @media (max-width: 1199px) {
    font-size: 20px;
    width: 600px;
  }
  @media (max-width: 991px) {
    font-size: 18px;
    width: 500px;
  }
  @media (max-width: 767px) {
    font-size: 16px;
    width: 450px;
  }
  @media (max-width: 575px) {
    width: auto;
  }
  @media (max-width: 400px) {
    font-size: 14px;
  }
`

const B = styled.b`
  margin: 29px 0 15px;
  font-size: 20px;
  @media (max-width: 991px) {
    font-size: 18px;
  }
  @media (max-width: 767px) {
    font-size: 20px;
  }
`

const Vertical = styled(motion.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 18px;
    @media (max-width: 1199px) {
      font-size: 17px;
    }
    @media (max-width: 991px) {
      font-size: 15px;
    }
    @media (max-width: 767px) {
      font-size: 18px;
      margin-bottom: 50px;
    }
  }
`

const H2 = styled.h2`
  text-align: center;
  font-weight: bold;
  margin: 21px 0 94px;
  @media (max-width: 767px) {
    margin: 21px 0 60px;
  }
`

const VideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 130px;
  width: 100%;
  height: 750px;
  background-size: cover;
  background-image: url('/video-background.png');
  @media (max-width: 767px) {
    height: 600px;
  }
  @media (max-width: 575px) {
    height: 500px;
  }
  @media (max-width: 420px) {
    height: 430px;
  }
`

export const Main = () => {
  const Options = { dragFree: false, loop: true }

  const partnerLogos = [
    { src: 'sunnylupin', padding: '5px' },
    { src: 'sebang', padding: '25px' },
    { src: 'xiangxin', padding: '10px' },
    { src: 'stx', padding: '23px' },
    { src: 'asiaenergy', padding: '5px' },
    { src: 'daiduckpiping', padding: '15px' },
    { src: 'pio', padding: '28px' },
    { src: 'cj', padding: '10px' },
    { src: 'goldencon', padding: '26px' },
    { src: 'geumgang', padding: '8px' },
    { src: 'oci', padding: '20px' },
    { src: 'taewoong', padding: '17px' },
    { src: 'kkl', padding: '10px' },
    { src: 'easyholdings', padding: '10px' },
    { src: 'junglobal', padding: '15px' },
    { src: 'bns', padding: '21px' },
  ]

  return (
    <div>
      <Banner />
      <div id="belt">
        <P>
          스마트 물류 시스템과 맞춤형 솔루션으로
          <br />
          효율적이고 신뢰할 수 있는 종합 물류 서비스를 제공합니다.
        </P>
        <div
          className="flex-grow-1 w-100 my-auto d-none d-sm-block"
          style={{ height: '1px', borderBottom: '1px solid white' }}
        />
      </div>
      <Container>
        <Point pointWidth={51} pointHeight={20} pointRadius="15px" />
        <div className="d-md-flex justify-content-between mt-5">
          <Vertical whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}>
            <picture>
              <source srcSet="/main-img/smart.webp" type="image/webp" />
              <img
                className="main-imgs"
                src="/main-img/smart.jpg"
                alt="스마트 물류 시스템"
                width={350}
                height={350}
              />
            </picture>
            <B>스마트 물류 시스템</B>
            <p style={{ textAlign: 'center' }}>
              최신 설비와 체계적인 운영으로
              <br />
              효율적인 물류 서비스를 제공합니다.
            </p>
          </Vertical>
          <Vertical whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}>
            <picture>
              <source srcSet="/main-img/note.webp" type="image/webp" />
              <img
                className="main-imgs"
                src="/main-img/note.jpg"
                alt="맞춤형 솔루션"
                width={350}
                height={350}
              />
            </picture>
            <B>맞춤형 솔루션</B>
            <p style={{ textAlign: 'center' }}>
              고객 요구에 맞춘
              <br />
              유연한 물류 서비스를 제공합니다.
            </p>
          </Vertical>
          <Vertical whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}>
            <picture>
              <source srcSet="/main-img/sj-side.webp" type="image/webp" />
              <img
                className="main-imgs"
                src="/main-img/sj-side.jpg"
                alt="종합 물류 서비스"
                width={350}
                height={350}
              />
            </picture>
            <B>종합 물류 서비스</B>
            <p style={{ textAlign: 'center' }}>
              대형 창고와 포장 야드로
              <br />
              종합적인 물류 지원을 제공합니다.
            </p>
          </Vertical>
        </div>
      </Container>
      <VideoWrapper>
        <Point pointWidth={51} pointHeight={20} pointRadius="15px" />
        <H2>서진로지텍 영상</H2>
        <video controls autoplay muted>
          <source src="/video/video.mp4" type="video/mp4" />
        </video>
      </VideoWrapper>
      <EmblaCarousel options={Options} />
      <section id="partners" style={{ margin: '155px 0' }}>
        <Container>
          <h2 className="fw-bold text-center">OUR PARTNERS</h2>
          <div id="partner-logos">
            {partnerLogos.map((logo, index) => (
              <Logo key={index} src={logo.src} padding={logo.padding} />
            ))}
          </div>
        </Container>
      </section>
    </div>
  )
}
